export type SessionSlot = {
  days: string
  time: string
}

export type GroupProgram = {
  id: string
  eyebrow: string
  title: string
  duration: string
  cap: string
  slots: SessionSlot[]
  body: string
  detail: string[]
  priceLabel: string
  priceOptions?: string[]
}

export const GROUP_PROGRAMS: GroupProgram[] = [
  {
    id: 'advanced-performance',
    eyebrow: 'High School · Ages 14+ · Every Sport',
    title: 'Advanced Performance',
    duration: '75 minute sessions',
    cap: 'Capped at 10 athletes',
    slots: [
      {
        days: 'Tuesday and Thursday',
        time: '5:45 to 7:00 PM',
      },
    ],
    body: 'Small-group strength and speed coaching for high school athletes in every sport. One group, one standard, coached by the Director of Performance.',
    detail: [
      'Free athlete evaluation to start',
      'Force plate and speed gate testing every 4 weeks',
      'Small-group strength and speed coaching',
      'Periodized programming across the fall season',
    ],
    priceLabel: 'From $180 per month',
  },
  {
    id: 'homeschool-multisport',
    eyebrow: 'Homeschool Athletes',
    title: 'Homeschool Multisport',
    duration: '90 minute sessions on Tuesday and Thursday',
    cap: 'Capped at 10 athletes',
    slots: [
      {
        days: 'Tuesday and Thursday',
        time: '2:30 to 4:00 PM',
      },
      {
        days: 'Monday',
        time: '10:00 AM start',
      },
      {
        days: 'Wednesday',
        time: '12:00 PM start',
      },
    ],
    body: 'A daytime athletic period for homeschool athletes. Speed, strength, coordination, and movement skills in a coached small group.',
    detail: [
      'Free athlete evaluation to start',
      'Daytime blocks that fit a homeschool week',
      'Testing every 4 weeks on the same markers',
      'Coached small group, never a drop-off workout',
    ],
    priceLabel: 'From $225 per month',
    priceOptions: ['1x / week · $225 per month', '2x / week · $400 per month'],
  },
]

export const SPEED_SCHOOL = {
  eyebrow: 'September 12 + 26 · Saturdays · 9:30 to 11:00 AM',
  title: 'Speed Training and Testing',
  summary:
    'Two Saturday sessions of coached sprint training, plus full speed and force plate testing so the athlete leaves with real numbers.',
  bothSessions: '$125 for both sessions',
  dropIn: '$75 drop-in',
  cap: '15 athletes max',
  location: 'INPOWERiQ · 6051 Alma Road, McKinney',
  flyer:
    'https://cdn.magicpatterns.com/uploads/wBjbJ523VAKHVQDgFivzsT/Reach-SpeedSchool-Sep12-26.jpg',
} as const

export const HIGH_SCHOOL_FLYER =
  'https://cdn.magicpatterns.com/uploads/9huR7sdvezGKFkvevLSBZs/Reach-HighSchool-5-45.jpg'
